import { render, staticRenderFns } from "./ArenaRoom.vue?vue&type=template&id=68f8be40&scoped=true&"
import script from "./ArenaRoom.vue?vue&type=script&lang=js&"
export * from "./ArenaRoom.vue?vue&type=script&lang=js&"
import style0 from "./ArenaRoom.vue?vue&type=style&index=0&id=68f8be40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f8be40",
  null
  
)

export default component.exports